<template>
    <b-row>
        <b-colxx v-for="(file, index) in files" :key="file.attachment_id" xxs="12" :lg="!edit ? 3 : 6"
                 :class="marginBottom ? `mb-${marginBottom}` : 'mb-4'">
            <b-card class="d-flex flex-row listing-card-container" no-body>
                <div class="w-40 position-relative" style="height: 100px;">
                    <div class="position-relative">
                        <template v-if="!edit">
                            <a v-if="file.data.attributes.extension === 'pdf'" target="_blank"
                               :href="file.data.attributes.url">
                                <span class="iconsminds-file menu-icon-style card-img-left" style="font-size: 70px; height: 100px;"/>
                            </a>

                            <single-lightbox v-else class-name="card-img-left" style="height: 100px;"
                                             :thumb="file.data.attributes.url" :large="file.data.attributes.url"/>
                        </template>

                        <template v-else>
                            <a v-if="file.data.attributes.extension === 'pdf'" target="_blank"
                               :href="file.data.attributes.url">
                                <span class="iconsminds-file menu-icon-style card-img-left" style="font-size: 70px; height: 100px;"/>
                            </a>

                            <img v-else class="card-img-left" style="height: 100px;"
                                             :src="file.data.attributes.url"/>
                        </template>
                    </div>
                </div>

                <div class="position-absolute card-top-delete-buttons">
                    <b-button variant="outline-primary" @click="deleteFile({...file, index})" class="icon-delete-button">
                        <i class="simple-icon-trash"/>
                    </b-button>
                </div>

                <div class="w-60 ml-0 d-flex align-items-center">
                    <b-card-body style="padding: 1.2rem;">
                        <span class="listing-heading" :title="file.data.attributes.file_name" v-line-clamp="1">
                            {{ file.data.attributes.file_name }}
                        </span>
                        <small :title="file.data.attributes.uploaded_on" class="text-muted" v-line-clamp="1">
                            {{ file.data.attributes.uploaded_on }}
                        </small>
                    </b-card-body>
                </div>
            </b-card>
        </b-colxx>
    </b-row>
</template>

<script>
    import SingleLightbox from "../Pages/SingleLightbox";

    export default {
        name: "FilesList",

        props: ['files', 'edit', 'marginBottom'],

        components: {
            SingleLightbox
        },

        methods: {
            deleteFile(file) {
                this.$emit('delete', file);
            },
        },
    }
</script>

<style scoped>

</style>
